import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {},
  records: {},
  uiFlags: {
    // Distingue "ainda não busquei" de "busquei e o agente não tem time" — sem
    // isso o filtro de conversation_team_manage zerava a lista em silêncio
    // durante a janela entre o fetch de conversas e o de times.
    isFetched: false,
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
